import api from './axios';

// Get all news (public)
export const getAllNews = async (params = {}) => {
  const response = await api.get('/news', { params });
  return response.data;
};

// Get all news (admin - includes inactive)
export const getAllNewsAdmin = async (params = {}) => {
  const response = await api.get('/news/admin/all', { params });
  return response.data;
};

// Get categories
export const getCategories = async () => {
  const response = await api.get('/news/categories');
  return response.data;
};

// Get single news
export const getNewsById = async (id) => {
  const response = await api.get(`/news/${id}`);
  return response.data;
};

// Create news
export const createNews = async (formData) => {
  const response = await api.post('/news', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update news
export const updateNews = async (id, data) => {
  // Check if data is FormData (for multipart updates with new image)
  const config = data instanceof FormData ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  
  const response = await api.patch(`/news/${id}`, data, config);
  return response.data;
};

// Delete news
export const deleteNews = async (id) => {
  const response = await api.delete(`/news/${id}`);
  return response.data;
};

// Toggle news status
export const toggleNewsStatus = async (id) => {
  const response = await api.patch(`/news/${id}/toggle`);
  return response.data;
};

// Bulk delete news
export const bulkDeleteNews = async (ids) => {
  const response = await api.delete('/news/bulk/delete', { data: { ids } });
  return response.data;
};
